import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MFAVerificationChallengePage } from "../../../components/pages/mfa/verification-challenge";
import { MFAExpiredPage } from "../../../components/pages/mfa/expired";
import { NoMenuNavigationBar } from "../../../components/parts/nomenu-navigation-bar";
import { post } from "../../../lib/request";
import { endpoint } from "../../../../../server/router/endpoint";
import { clientEndpoint } from "../../../routes/endpoint";
import {
	VerifyVerificationChallengeRequest,
	VerifyVerificationChallengeResponse,
} from "../../../../../shared/verification-challenge";

type LocationState = { email?: string; token?: string } | null;

const verifyFailedMessage = "認証に失敗しました。コードを確認して、もう一度お試しください。";

export const MFAVerificationChallengeContainer = () => {
	const navigate = useNavigate();
	// ログイン画面から渡されるチャレンジトークン（リロードすると失われる）
	const { email, token } = (useLocation().state as LocationState) ?? {};
	const [error, setError] = React.useState<string>();
	const [isPending, setIsPending] = React.useState<boolean>(false);

	const onSubmit = React.useCallback(
		(code: string) => {
			const request: VerifyVerificationChallengeRequest = { code, token };
			setIsPending(true);
			return post<VerifyVerificationChallengeResponse>(endpoint.verificationChallengeVerify, request)
				.then((response) => {
					// 一時セッション用トークンを渡してMFAセットアップへ
					navigate(clientEndpoint.mfaSetup, { replace: true, state: { token: response.data.token } });
				})
				.catch((error) => {
					setError(verifyFailedMessage);
					throw error;
				})
				.finally(() => setIsPending(false));
		},
		[navigate, token],
	);

	return (
		<>
			<NoMenuNavigationBar />
			{token ? (
				<MFAVerificationChallengePage email={email ?? ""} error={error} isPending={isPending} onSubmit={onSubmit} />
			) : (
				<MFAExpiredPage />
			)}
		</>
	);
};
